import { render, staticRenderFns } from "./PriceTable.vue?vue&type=template&id=0178009e&scoped=true&"
import script from "./PriceTable.vue?vue&type=script&lang=ts&"
export * from "./PriceTable.vue?vue&type=script&lang=ts&"
import style0 from "./PriceTable.vue?vue&type=style&index=0&id=0178009e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0178009e",
  null
  
)

export default component.exports